import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MonitorSmartphone, Share2, Search } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Web Development',
    description: 'We build beautiful, fast websites that look great on phones and computers. Your website will be easy for your customers to use and easy for you to manage.',
    icon: <MonitorSmartphone size={32} data-id="element-190" />,
    color: 'bg-blue-50 text-blue-600 border-blue-100'
  }, {
    title: 'Social Media Management',
    description: 'We handle your Facebook, Instagram, and other social accounts. We post engaging content that gets people talking about your business and brings them to your door.',
    icon: <Share2 size={32} data-id="element-191" />,
    color: 'bg-green-50 text-sum-green border-green-100'
  }, {
    title: 'SEO Optimization',
    description: 'We use smart keywords to help your business show up higher on Google. When people search for what you sell, we make sure they find you first.',
    icon: <Search size={32} data-id="element-192" />,
    color: 'bg-yellow-50 text-sum-gold border-yellow-100'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="py-20 bg-sum-light" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-extrabold text-sum-charcoal mb-4" data-id="element-196">
            Simple Services, Big Results
          </h2>
          <p className="text-xl text-gray-600" data-id="element-197">
            Everything you need to get more customers online, explained in plain
            English.
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-198">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-199">
              <div className={`inline-flex items-center justify-center p-4 rounded-xl mb-6 border ${service.color}`} data-id="element-200">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold text-sum-charcoal mb-4" data-id="element-201">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-202">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}